import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  ManureStorageSourceDto,
  ManureStorageDurationDto,
  ManureStorageTypeDto,
  ManureStorageSourceServiceServiceProxy,
  ManureStorageDurationServiceServiceProxy,
  ManureStorageTypeServiceServiceProxy,
  FarmerManureStorageServiceServiceProxy
} from '@shared/service-proxies/service-proxies';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { LoadingController, AlertController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-manure-storage',
  templateUrl: './manure-storage.page.html',
  styleUrls: ['./manure-storage.page.scss'],
})
export class ManureStoragePage implements OnInit {

  formGroup: FormGroup;
  manureStorageSources: ManureStorageSourceDto[] = [];
  manureStorageDurations: ManureStorageDurationDto[] = [];
  manureStorageTypes: ManureStorageTypeDto[] = [];
  isLoaded: boolean = false;

  @Input() farmerId: number;

  constructor(
    private formBuilder: FormBuilder,
    storageService: AppStorageService,
    private loadingController: LoadingController,
    private alertController: AlertController,
    private modalController: ModalController,
    private manureStorageSourceService: ManureStorageSourceServiceServiceProxy,
    private manureStorageDurationService: ManureStorageDurationServiceServiceProxy,
    private manureStorageTypeService: ManureStorageTypeServiceServiceProxy,
    private farmerManureStorageService: FarmerManureStorageServiceServiceProxy
  ) { 
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.getDropdownData();
        this.isLoaded = true;
      }
    });
    this.setupForm();
  }

  ngOnInit() {
  }

  getDropdownData() {
    this.manureStorageSourceService.getAll().subscribe(items => {
      this.manureStorageSources = items;
    });
    this.manureStorageDurationService.getAll().subscribe(items => {
      this.manureStorageDurations = items.sort((a,b) => parseInt(a.name) - parseInt(b.name)); 
    });
    this.manureStorageTypeService.getAll().subscribe(items => {
      this.manureStorageTypes = items;
    });
  }

  setupForm() {
    this.formGroup = this.formBuilder.group({
      manureStorageSourceId: ['', [Validators.required]],
      manureStorageDurationId: ['', [Validators.required]],
      manureStorageTypeId: ['', [Validators.required]],
    });
  }

  submitForm() {
    this.saveManureStorage();
  }

  async saveManureStorage() {
    
    const loading = await this.loadingController.create({
      message: 'Saving...',
    });
    await loading.present();
    
    const ms = this.formGroup.getRawValue();
    ms.farmerId = this.farmerId;
    this.farmerManureStorageService.create(ms).subscribe(
      async dto => {
        await loading.dismiss();
        this.modalController.dismiss({
          'dto': dto
        });
      },
      async error => {
        this.saveError(error).then();
        await loading.dismiss();
      }
    );
    
  }

  async saveError(errorMessage) {
    const alert = await this.alertController.create({
      header: 'Error',
      subHeader: 'Error',
      message: errorMessage,
      buttons: ['OK']
    });

    await alert.present();
  }

  cancel() {
    this.modalController.dismiss();
  }

}
